import type { JSX } from "react";
import { useTranslation } from "react-i18next";

import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import Box from "@mui/material/Box";

import Button from "../../components/Button";
import { logout } from "../../services/auth";

import "./index.scss";

const LogoutButton = (): JSX.Element => {
  const { t } = useTranslation();
  return (
    <Box className="logout" onClick={logout} sx={{ cursor: "pointer" }}>
      <Button title={t("logout")} iconSize="medium" icon={<ExitToAppIcon />} />
    </Box>
  );
};

export default LogoutButton;
